module.exports = __webpack_public_path__ + "static/media/p3_5.5e0bcdf6.png";